<template>
  <ContainerSmall>
    <img src="/images/Cardstock_Logo.png" class="block mx-auto mt-16 w-48 mb-4">
    <div class="border rounded shadow-md bg-white px-4 py-4 mx-4 sm:mx-0">
      <div class="text-black font-normal text-xl text-center mb-4">
        Can't log in?
      </div>

      <div
        v-if="emailAddressFound === false"
        class="bg-cardstock-yellow-400 rounded-lg p-4 text-base"
      >
        <p class="mb-4 font-bold">
          Sorry, we didn’t recognize that email address. Want to try another?
        </p>
        <p>
          If you’d like some extra help, email Lanny at <a href="mailto:Lanny.Bose@cardstockforteachers.com"> Lanny.Bose@cardstockforteachers.com</a>.
        </p>
      </div>

      <div
        v-else-if="emailAddressFound === true"
        class="bg-cardstock-yellow-400 rounded-lg p-4 text-base"
      >
        <p>
          You should receive an email with instructions for logging in.
        </p>
      </div>

      <Mutation
        :mutation="mutation"
        :variables="variables"
        @done="onDone"
        @error="onError"
      >
        <template v-slot="{ mutate, loading }">
          <ValidationObserver
            ref="observer"
            tag="form"
            @submit.prevent="submit(mutate)"
          >
            <div class="sm:flex sm:items-start my-6">
              <div class="sm:mt-0 sm:text-left w-full">
                <TextInput v-model="proposedEmail" name="email" label="Enter your email address" rules="required"/>
              </div>
            </div>

            <button
              type="submit"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              :class="[ loading ? 'bg-gray-500' : 'bg-cardstock-green' ]"
              :disabled="loading"
            >
              Email me reset instructions
              <font-awesome-icon v-show="loading" class="ml-2" :icon="['far', 'spinner']" spin/>
            </button>
          </ValidationObserver>
        </template>
      </Mutation>

      <div class="text-sm font-bold mt-8">
        If you don't see your reset email...
      </div>
      <div class="text-sm">
        Be sure to check your spam filter for an email from <em>Lanny.Bose@cardstockforteachers.com</em>
      </div>
    </div>
    <div class="mt-8 text-sm text-center">
      <strong>
        Nevermind,
      </strong>
      <router-link :to="{name: 'login'}">
        go back to the login screen
      </router-link>
    </div>
  </ContainerSmall>
</template>

<script>
import ContainerSmall from '@/components/ContainerSmall.vue'
import Mutation from '@/components/Mutation.vue'
import PasswordResetCreate from '@/mutations/PasswordResetCreate.gql'
import TextInput from '@/components/TextInput.vue'


export default {
  components: {
    ContainerSmall,
    Mutation,
    TextInput
  },

  data() {
    return {
      proposedEmail: '',
      mutation: PasswordResetCreate,
      emailAddressFound: undefined,
      errored: undefined
    }
  },

  computed: {
    variables() {
      return {
        email: this.proposedEmail
      }
    }
  },

  methods: {
    onDone({passwordResetCreate}) {
      this.errored = false
      this.emailAddressFound = passwordResetCreate.emailAddressFound
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
      console.log(error)
    },

    async submit(mutate) {
      const isValid = await this.$refs.observer.validate()
      if (isValid) { mutate() }
    }
  }
}
</script>
